// src/pages/Admin/Notifications/view/OnlyNotificationView.tsx

import React from "react";
import { Grid } from "@material-ui/core";
import { useParams } from "react-router-dom";

import BreadcrumbAndTitle from "@components/BreadcrumbAndTitle";
import { BreadcrumbChild } from "@components/BreadcrumbCustom";

import ROUTES from "@config/routes";

import NotificationFormikContainer from "../resource/form/NotificationFormikContainer";
import { NotificationFormModeEnum } from "../resource/form/hook/interface";

interface RouteParams {
  id?: string;
}

const OnlyNotificationView: React.FC = () => {
  const { id } = useParams<RouteParams>();

  const breadcrumbData: BreadcrumbChild[] = [
    { label: "Início", link: ROUTES.ADMIN_ROUTES.HOME },
    { label: "Notificações", link: ROUTES.ADMIN_ROUTES.NOTIFICATIONS.ROOT },
    { label: id ? `Visualizar #${id}` : "Visualizar" },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <BreadcrumbAndTitle
          breadcrumbData={breadcrumbData}
          title={id ? `Visualizar Notificação #${id}` : "Notificação"}
        />
      </Grid>

      <Grid item xs={12}>
        <NotificationFormikContainer mode={NotificationFormModeEnum.VIEW} />
      </Grid>
    </Grid>
  );
};

export default OnlyNotificationView;
